export const ROLE = {
  I_SUPER_ADMIN: 'Super Admin',
  I_LOCAL_ADMIN: 'IM Local Admin',
  P_SUPER_ADMIN: 'Partner Super Admin',
  P_LOCAL_ADMIN: 'Partner Local Admin',
  MENTOR: 'Mentor',
  MENTEE: 'Mentee',
};

export const ChatType = {
  GROUP: 'group',
  PRIVATE: 'pair',
  FOCUS: 'focus',
};

export const MessageStatus = {
  READ: 'Read',
  DELIVERED: 'Delivered',
  SENT: 'Sent',
};

export const PromptConstants = {
  NO_PROMPTS_MESSAGE: "You're all caught up! 🙌 Any new prompts will appear here as they're posted.",
  EMPTY_OPEN_RESPONSE: 'Message cannot be blank. Please enter a response.',
};

export const MilestonesMeta = [
  {
    key: 'createdCollegeList',
    label: 'Have you created a college list?',
  },
  {
    key: 'appliedToCollege',
    label: 'Have you applied to college?',
  },
  {
    key: 'beenAcceptedToCollege',
    label: 'Have you been accepted to college?',
  },
  {
    key: 'completedFAFSA',
    label: 'Are you completing the FAFSA?',
  },
  {
    key: 'intendToEnrollInTwoOrFourYear',
    label: 'Do you intend to enroll in a two-year or four-year college?',
  },
  {
    key: 'planToPayForCollege',
    label: 'Do you have a plan to pay for college?',
  },
  {
    key: 'selectedACollege',
    label: 'Have you selected a college?',
  },
];
